/* PrimeLux v2: header mega menu (hover intent) + small progressive enhancements. Vanilla, deferred, ~3 KB. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var desktop = window.matchMedia('(min-width: 990px)');
  var lastTouch = 0;
  document.documentElement.classList.add('v2-js');
  document.addEventListener('touchstart', function () { lastTouch = Date.now(); }, { passive: true, capture: true });

  /* Mega menu. The panel lives inside its <li>, directly under the nav row (top: 100% of the nav, no gap), so the
     pointer never crosses dead space. Open after 90 ms of hover (140 ms when switching items, so a diagonal path
     doesn't steal the panel). It stays open while the pointer is anywhere over the nav row or the open panel and
     closes 380 ms after it leaves both. Labels are real links (click navigates). Touch/pen: first tap opens, second
     tap navigates. Chevron button toggles (keyboard), ArrowDown enters the panel, Esc closes and returns focus. */
  function initNav(root) {
    $$('[data-v2-nav]', root).forEach(function (nav) {
      if (nav.dataset.v2Bound) return; nav.dataset.v2Bound = '1';
      var header = nav.closest('[data-v2-header]') || nav;
      var current = null, how = '', tOpen = 0, tClose = 0;
      var OPEN = 90, SWITCH = 140, CLOSE = 380;
      function setAria(li, on) { var b = $('[data-v2-toggle]', li); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false'); }
      function close(li) {
        li = li || current; clearTimeout(tOpen); clearTimeout(tClose);
        if (!li) return;
        li.classList.remove('is-open'); setAria(li, false);
        if (li === current) { current = null; how = ''; header.classList.remove('has-open-panel'); }
      }
      function open(li, mode) {
        clearTimeout(tOpen); clearTimeout(tClose);
        if (current && current !== li) close(current);
        li.classList.add('is-open'); setAria(li, true);
        current = li; how = mode; header.classList.add('has-open-panel');
      }
      /* Decide per event, not by media query: touchscreen laptops report (pointer: coarse) even when a mouse is used,
         which previously disabled hover entirely. Mouse events count unless a touch happened in the last 800 ms. */
      function isMouse(e) {
        if (!desktop.matches) return false;
        if (e.pointerType) return e.pointerType === 'mouse';
        return Date.now() - lastTouch > 800;
      }
      function scheduleClose() {
        clearTimeout(tClose);
        tClose = setTimeout(function () {
          if (!current) return;
          if (nav.matches(':hover')) return;           // still over the row or a panel
          if (how !== 'hover' && current.contains(document.activeElement)) return;
          close();
        }, CLOSE);
      }
      $$('[data-v2-item]', nav).forEach(function (li) {
        var label = $('[data-v2-label]', li), toggle = $('[data-v2-toggle]', li), lastPointer = 'mouse';
        function enter(e) {
          if (!isMouse(e)) return;
          clearTimeout(tClose);
          if (current === li) return;
          clearTimeout(tOpen);
          tOpen = setTimeout(function () { open(li, 'hover'); }, current ? SWITCH : OPEN);
        }
        function leave(e) { if (isMouse(e)) clearTimeout(tOpen); }
        /* pointer events where supported, mouse events as a fallback (both are safe: enter() is idempotent). */
        li.addEventListener('pointerenter', enter);
        li.addEventListener('mouseenter', enter);
        li.addEventListener('pointerleave', leave);
        li.addEventListener('mouseleave', leave);
        if (label) {
          label.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
          label.addEventListener('click', function (e) {
            if (lastPointer !== 'mouse' && desktop.matches && current !== li && e.detail !== 0) { e.preventDefault(); open(li, 'tap'); }
            lastPointer = 'mouse';
          });
        }
        if (toggle) toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (current === li && how !== 'hover') close(li); else open(li, 'toggle');
        });
        li.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' && (e.target === label || e.target === toggle)) {
            e.preventDefault(); open(li, 'toggle');
            var first = $('[data-v2-panel] a:not([tabindex="-1"])', li); if (first) first.focus();
          }
        });
        li.addEventListener('focusout', function (e) {
          if (current === li && how !== 'hover' && !li.contains(e.relatedTarget)) close(li);
        });
      });
      ['pointerenter', 'mouseenter'].forEach(function (t) { nav.addEventListener(t, function (e) { if (isMouse(e)) clearTimeout(tClose); }); });
      ['pointerleave', 'mouseleave'].forEach(function (t) { nav.addEventListener(t, function (e) { if (isMouse(e) && current) scheduleClose(); }); });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !current) return;
        var li = current, had = li.contains(document.activeElement); close(li);
        if (had) { var b = $('[data-v2-toggle]', li); if (b) b.focus(); }
      });
      document.addEventListener('click', function (e) { if (current && !current.contains(e.target)) close(); });
      desktop.addEventListener && desktop.addEventListener('change', function () { close(); });
    });
  }

  /* --header-h = real sticky header height (used by sticky galleries and drawers). */
  function headerHeight() {
    var h = $('[data-v2-header]'); if (!h) return;
    var set = function () { document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px'); };
    set(); if ('ResizeObserver' in window) new ResizeObserver(set).observe(h);
  }

  /* Before/after: the range input drives --pos on its comparison (clip-path in CSS). Delegated, so it survives section reloads. */
  document.addEventListener('input', function (e) {
    var r = e.target; if (!r.matches || !r.matches('[data-v2-ba-range]')) return;
    var ba = r.closest('[data-v2-ba]'); if (ba) ba.style.setProperty('--pos', r.value + '%');
  });

  /* Sticky buy bar (guides): shown once the first section has scrolled out of view. */
  function initBuyBar() {
    var bar = $('[data-v2-buybar]'); if (!bar || !('IntersectionObserver' in window)) return;
    var first = $('main .shopify-section'); if (!first) { bar.hidden = false; return; }
    new IntersectionObserver(function (en) { bar.hidden = en[0].isIntersecting; document.body.classList.toggle('has-v2-buybar', !bar.hidden); }).observe(first);
  }
  function init(root) { initNav(root); initBuyBar(); }
  headerHeight();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* v3 concern finder: concern must match; prefer skin-type match and price within budget, else the cheapest match. */
(function () {
  document.querySelectorAll('[data-v3-finder]').forEach(function (form) {
    var sec = form.closest('section');
    var notes = { oily: 'For oily skin: keep the skin clean and dry before each session and skip heavy creams straight after.', dry: 'For dry skin: follow every session with a rich moisturiser.', combination: 'For combination skin: focus on the areas that need it most.', sensitive: 'For sensitive skin: start with shorter sessions and patch test first.', normal: 'For normal skin: follow the routine as written, a few times a week.' };
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var c = (form.querySelector('[name=concern]:checked') || {}).value;
      var s = (form.querySelector('[name=skin]:checked') || {}).value || '';
      var b = parseFloat((form.querySelector('[name=budget]:checked') || {}).value || '99999');
      if (!c) { form.querySelector('[name=concern]').focus(); return; }
      var all = [].slice.call(sec.querySelectorAll('[data-v3-result]'));
      all.forEach(function (r) { r.hidden = true; });
      var m = all.filter(function (r) { return r.dataset.concern === c; });
      var skinOk = function (r) { var k = r.dataset.skin || 'all'; return !s || k.indexOf('all') > -1 || k.indexOf(s) > -1; };
      var pool = m.filter(skinOk); if (!pool.length) pool = m;
      var inBudget = pool.filter(function (r) { return parseFloat(r.dataset.price) <= b; });
      var pick = inBudget.sort(function (x, y) { return y.dataset.price - x.dataset.price; })[0] || pool.sort(function (x, y) { return x.dataset.price - y.dataset.price; })[0];
      var none = form.querySelector('[data-v3-finder-none]');
      if (none) none.hidden = !!pick;
      if (pick) { pick.hidden = false; var n = pick.querySelector('[data-v3-skin-note]'); if (n) n.textContent = notes[s] || ''; pick.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    });
  });
})();

/* v3 set-vs-device anchor: the checked option's variant id goes into the product form (set preselected). */
(function () {
  function apply(fs) {
    var sec0 = fs.closest('[data-product-section]'); var form = document.getElementById(fs.dataset.form) || (sec0 && sec0.querySelector('[data-main-atc] form')); if (!form) return;
    var input = form.querySelector('[data-variant-id]'); var r = fs.querySelector('input:checked'); if (!input || !r) return;
    if (r.hasAttribute('data-own')) { r.value = input.dataset.ownId || r.value; }
    if (!input.dataset.ownId) input.dataset.ownId = input.value;
    input.value = r.hasAttribute('data-own') ? input.dataset.ownId : r.value;
    var sec = fs.closest('[data-product-section]'); if (!sec || !r.dataset.money) return;
    var isSet = !r.hasAttribute('data-own'); sec.classList.toggle('v3-is-set', isSet);
    sec.querySelectorAll('[data-price] [data-price-current], [data-sticky-price]').forEach(function (el) {
      if (!el.dataset.ownHtml) el.dataset.ownHtml = el.innerHTML;
      if (isSet) el.textContent = r.dataset.money; else el.innerHTML = el.dataset.ownHtml;
    });
  }
  function init() { document.querySelectorAll('[data-v3-anchor]').forEach(function (fs) { if (fs.dataset.ready) return; fs.dataset.ready = '1'; apply(fs); fs.addEventListener('change', function () { apply(fs); }); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* v3 review filters (concern / skin tone) */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.v3-rfilter__btn'); if (!b) return;
    var wrap = b.closest('[data-v3-rfilter]'); var sec = wrap.closest('section');
    wrap.querySelectorAll('.v3-rfilter__btn').forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    sec.querySelectorAll('.v2-quote').forEach(function (q) { q.hidden = !!b.dataset.k && q.dataset[b.dataset.k] !== b.dataset.v; });
  });
})();

/* v3 menu images: no request until the shopper shows intent (hover/focus/touch on the header, or opening the drawer).
   Small thumbnails are also fetched when the browser is idle after load, so panels open with photos already there. LCP untouched. */
(function () {
  var all = false, thumbs = false;
  function set(list) { list.forEach(function (i) { if (i.dataset.v3Src) { i.src = i.dataset.v3Src; i.removeAttribute('data-v3-src'); } }); }
  function loadAll() { if (all) return; all = true; set(document.querySelectorAll('img[data-v3-src]')); }
  function loadThumbs() { if (thumbs || all) return; thumbs = true; set(document.querySelectorAll('.v3-mega__thumb img[data-v3-src], .v3-mega__group-media img[data-v3-src], .v3-drawer__thumb img[data-v3-src]')); }
  function init() {
    var h = document.querySelector('[data-v2-header]');
    if (h) ['pointerover', 'focusin', 'touchstart'].forEach(function (e) { h.addEventListener(e, loadAll, { once: true, passive: true }); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-drawer-open]')) loadAll(); }, true);
    var idle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(loadThumbs, { timeout: 3000 }); };
    if (document.readyState === 'complete') setTimeout(idle, 3000); else window.addEventListener('load', function () { setTimeout(idle, 3000); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { all = false; thumbs = false; loadAll(); });
})();

/* v4.4 Pick your product cards: the checked card's variant goes into the ONE product form.
   Variant cards drive the (hidden) option picker, so price, images and the sticky bar update as before.
   Bundle cards swap the shown price + sticky bar to the bundle; the product's own card restores them. */
(function () {
  function q(s, r) { return (r || document).querySelector(s); }
  function apply(fs, fromPicker) {
    var sec = fs.closest('[data-product-section]'); if (!sec) return;
    var form = document.getElementById(fs.dataset.form) || q('[data-main-atc] form', sec); if (!form) return;
    var idInput = q('[data-variant-id]', form); var r = q('.pl-pick__input:checked', fs); if (!idInput || !r) return;
    fs.querySelectorAll('.pl-pick__card').forEach(function (c) { c.classList.toggle('is-selected', c.contains(r)); });
    if (r.hasAttribute('data-option')) {
      var opt = sec.querySelector('[data-variant-picker] [data-option-input][value="' + r.dataset.option.replace(/"/g, '\\"') + '"]');
      if (opt && !opt.checked && !fromPicker) { opt.checked = true; opt.dispatchEvent(new Event('change', { bubbles: true })); }
      if (!fromPicker) idInput.value = r.value; // the card IS the variant: keep the form in step even if the picker can't match
      return;
    }
    var price = q('[data-product-price]', sec), sticky = q('[data-sticky-atc] .sticky-atc__meta', sec);
    if (r.hasAttribute('data-bundle')) {
      if (!fs._own) fs._own = { id: idInput.value, price: price && price.innerHTML, sticky: sticky && sticky.innerHTML };
      idInput.value = r.value;
      sec.classList.add('pl-is-bundle');
      if (price) {
        price.innerHTML = fs._own.price;
        var cur = q('[data-price-current]', price), cmp = q('[data-price-compare]', price), box = q('[data-price]', price);
        if (cur) cur.textContent = r.dataset.money;
        if (cmp) { cmp.textContent = r.dataset.compare || ''; cmp.hidden = !r.dataset.compare; }
        if (box) box.classList.toggle('price--sale', !!r.dataset.compare);
        price.querySelectorAll('[data-save-badge], [data-save-amount], .v3-payin4').forEach(function (el) { el.hidden = true; });
      }
      if (sticky) {
        sticky.innerHTML = fs._own.sticky;
        var t = q('.sticky-atc__title', sticky); if (t) t.textContent = r.dataset.title || t.textContent;
        var sp = q('[data-sticky-price]', sticky); if (sp) sp.textContent = r.dataset.money;
        var sw = q('[data-sticky-was]', sticky); if (sw) { sw.textContent = r.dataset.compare || ''; sw.hidden = !r.dataset.compare; }
        sticky.querySelectorAll('[data-sticky-save], [data-sticky-variant]').forEach(function (el) { el.hidden = true; });
      }
    } else if (fs._own) {
      idInput.value = fs._own.id;
      if (price && fs._own.price != null) price.innerHTML = fs._own.price;
      if (sticky && fs._own.sticky != null) sticky.innerHTML = fs._own.sticky;
      fs._own = null; sec.classList.remove('pl-is-bundle');
    }
  }
  function init() {
    document.querySelectorAll('[data-pl-pick]').forEach(function (fs) {
      if (fs.dataset.ready) return; fs.dataset.ready = '1';
      fs.addEventListener('change', function () { apply(fs); });
      var sec = fs.closest('[data-product-section]'); var picker = sec && q('[data-variant-picker]', sec);
      if (picker) picker.addEventListener('change', function (e) {
        if (fs.dataset.mode === 'variants') {
          var v = e.target.value; var card = fs.querySelector('.pl-pick__input[data-option="' + String(v).replace(/"/g, '\\"') + '"]');
          if (card && !card.checked) { card.checked = true; apply(fs, true); }
        } else {
          var own = q('.pl-pick__input[data-own]', fs);
          if (own && !own.checked) { own.checked = true; apply(fs, true); }
          var idI = sec.querySelector('[data-variant-id]'); if (own && idI) setTimeout(function () { own.value = idI.value; }, 0);
        }
      }, true);
      if (q('.pl-pick__input[data-bundle]:checked', fs)) apply(fs);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* v4.4 rotating review quotes: fade every N s (default 5), pause on hover/focus/hidden tab, dots to pick.
   Reduced motion: no auto-advance (dots still work). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    document.querySelectorAll('[data-pl-rotator]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var slides = [].slice.call(root.querySelectorAll('[data-pl-slide]'));
      if (!slides.length) { root.hidden = true; return; }
      var dotsWrap = root.querySelector('[data-pl-dots]'); var dots = [];
      var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { var on = k === i; s.classList.toggle('is-active', on); if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
        dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      if (slides.length > 1 && dotsWrap) {
        slides.forEach(function (s, k) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'pl-rot__dot'; b.setAttribute('aria-label', 'Show review ' + (k + 1) + ' of ' + slides.length);
          b.addEventListener('click', function () { show(k); }); dotsWrap.appendChild(b); dots.push(b);
        });
      }
      show(i);
      if (slides.length < 2 || reduce) return;
      var ms = Math.max(3, parseInt(root.dataset.interval, 10) || 5) * 1000, paused = false;
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (e) { root.addEventListener(e, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (e) { root.addEventListener(e, function () { paused = false; }); });
      setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, ms);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* v4.4 delivery estimate: today (South African time, UTC+2, no DST) + min/max business days, skipping weekends and the
   no-delivery dates. Cut-off countdown only when a cut-off time is set and it is a business day before that time. */
(function () {
  var D = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function key(d) { return d.toISOString().slice(0, 10); }
  function fmt(d) { return D[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + M[d.getUTCMonth()]; }
  function run(box) {
    var min = parseInt(box.dataset.min, 10) || 5, max = Math.max(min, parseInt(box.dataset.max, 10) || 7);
    var off = {}; (box.dataset.off || '').split(',').forEach(function (s) { if (/^\d{4}-\d{2}-\d{2}$/.test(s)) off[s] = 1; });
    var biz = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !off[key(d)]; };
    var now = new Date(Date.now() + 2 * 3600e3); // SAST wall clock in UTC fields
    var day = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var cut = /^(\d{1,2}):(\d{2})$/.exec((box.dataset.cutoff || '').trim()), left = 0;
    if (cut && biz(day)) {
      left = (+cut[1] * 60 + +cut[2]) - (now.getUTCHours() * 60 + now.getUTCMinutes());
      if (left <= 0) { left = 0; day = new Date(day.getTime() + 864e5); }
    }
    function add(n) { var d = new Date(day.getTime()), c = 0; while (c < n) { d = new Date(d.getTime() + 864e5); if (biz(d)) c++; } return d; }
    var a = add(min), b = add(max), el = box.querySelector('[data-pl-ship-eta]'); if (!el) return;
    var when = min === max ? 'get it by <strong>' + fmt(a) + '</strong>' : 'get it between <strong>' + fmt(a) + '</strong> and <strong>' + fmt(b) + '</strong>';
    var lead = 'Order today, ';
    if (left > 0) { var h = Math.floor(left / 60), m = left % 60; lead = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> to '; when = when.replace(/^get/, 'get'); }
    el.innerHTML = lead + when;
  }
  function init() {
    document.querySelectorAll('[data-pl-ship]').forEach(function (box) {
      run(box);
      if (box.dataset.cutoff && !box.dataset.tick) { box.dataset.tick = '1'; setInterval(function () { run(box); }, 60000); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* v5 hero: auto-scroll the mobile image carousel (scroll-snap row) every N ms; pauses on touch, hidden tab or when
   off-screen; no auto-advance for reduced motion. Dots follow the visible slide. Count-up on [data-v5-count]
   (final number is already in the HTML, so no layout shift and nothing changes without JS). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el) {
    if (el.dataset.done) return; el.dataset.done = '1';
    var to = parseInt(el.dataset.v5Count, 10) || 0, sfx = el.dataset.suffix || '';
    if (reduce || !to) return;
    var t0 = null, dur = 1400;
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e).toLocaleString('en-US') + sfx; if (p < 1) requestAnimationFrame(step); }
    el.textContent = '0' + sfx; requestAnimationFrame(step);
  }
  function init() {
    document.querySelectorAll('[data-v5-count]').forEach(function (el) {
      if ('IntersectionObserver' in window) { var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { countUp(el); o.disconnect(); } }); }); o.observe(el); } else countUp(el);
    });
    document.querySelectorAll('[data-v5-hero]').forEach(function (hero) {
      if (hero.dataset.ready) return; hero.dataset.ready = '1';
      var row = hero.querySelector('.v3-hero__panels'), dots = [].slice.call(hero.querySelectorAll('.v5-hero__dot'));
      if (!row) return; var n = row.children.length; if (n < 2) return;
      function idx() { return Math.round(row.scrollLeft / Math.max(1, row.clientWidth)); }
      row.addEventListener('scroll', function () { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }, { passive: true });
      var ms = parseInt(hero.dataset.autoplay, 10); if (!ms || reduce) return;
      var paused = false, vis = true, timer;
      ['touchstart', 'pointerdown', 'focusin'].forEach(function (e) { row.addEventListener(e, function () { paused = true; clearTimeout(timer); timer = setTimeout(function () { paused = false; }, 8000); }, { passive: true }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }).observe(hero);
      setInterval(function () {
        if (paused || !vis || document.hidden || row.scrollWidth <= row.clientWidth + 4) return; // desktop: 3 panels side by side, nothing to scroll
        var next = (idx() + 1) % n; row.scrollTo({ left: next * row.clientWidth, behavior: 'smooth' });
      }, ms);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* v6: Black Friday countdown (real date only), Private List join button, copy welcome code */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  document.querySelectorAll('[data-v6-cd]').forEach(function (el) {
    var t = Date.parse(el.getAttribute('data-v6-cd'));
    if (isNaN(t)) { el.hidden = true; return; }
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]');
    function tick() {
      var s = Math.floor((t - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; return false; }
      d.textContent = Math.floor(s / 86400); h.textContent = pad(Math.floor(s % 86400 / 3600)); m.textContent = pad(Math.floor(s % 3600 / 60));
      return true;
    }
    if (tick()) setInterval(tick, 30000);
  });
  document.addEventListener('click', function (e) {
    var j = e.target.closest && e.target.closest('[data-v6-join]');
    if (j) {
      var href = j.getAttribute('href') || '';
      if (href && href !== '#PrivateList') return;
      e.preventDefault();
      var pop = document.querySelector('[data-popup="welcome"]');
      if (pop) {
        pop.hidden = false; void pop.offsetWidth; pop.classList.add('is-open');
        var f = pop.querySelector('input[type=email]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
        return;
      }
      var su = document.querySelector('.v2-signup');
      if (su) { su.scrollIntoView({ behavior: 'smooth', block: 'start' }); var i = su.querySelector('input[type=email]'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 500); }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-v6-copy]');
    if (c) {
      var v = c.parentNode.querySelector('[data-v6-code]'); if (!v) return;
      var txt = v.textContent.trim();
      var done = function () { c.textContent = 'Copied'; setTimeout(function () { c.textContent = 'Copy'; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, done); else done();
    }
  });
})();
